import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { FlagType, userType } from '../../../shared/utils/enums';
import { CookieService } from 'ngx-cookie-service';
import { CandidatService } from '../../../services/candidat.service';
import { EstablishmentService } from '../../../services/establishment.service';
import { FlagService } from '../../../shared/services/flag.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  form: FormGroup = this.fb.group({
    email: ['', Validators.required],
    password: [
      '',
      [Validators.required],
      // [Validators.required, Validators.pattern(StrongPasswordRegx)],
    ],
    code : ['']
  });
  loading = false;
  user: any;
  showVerificationCodeForm = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private cookieService: CookieService,
    private condidatApi: CandidatService,
    private flag: FlagService,
    private establishmentService: EstablishmentService
  ) {}

  ngOnInit() {}

  get passwordFormField() {
    return this.form.get('password');
  }

  handleLogin() {
    this.loading = true;

    this.authService.login(this.form.value).subscribe({
      next: (value) => {
        // Only AGENCY and AGENCY_USER accounts may sign in on the agency app.
        const kind = value?.user?.kind;
        if (kind !== userType.agence && kind !== userType.agence_user) {
          this.flag.displayFlag(
            "Ce compte n'est pas autorisé à se connecter sur cet espace.",
            FlagType.error
          );
          this.loading = false;
          return;
        }
        this.user = value.user;
        // Convert the object to a JSON string
        const tokenObject = {
          'access-token': value.token.token,
          type: 'Bearer',
          client: value.token.client,
          expiry: value.token.expiry,
          uid: value.user.email,
        };
        const jsonString = JSON.stringify(tokenObject);
        // Encode the JSON string to Base64
        const base64token = btoa(jsonString);
        localStorage.setItem('user', JSON.stringify(this.user));

        this.cookieService.set('token', value.token.token);
        localStorage.setItem('token', value.token.token);
        localStorage.setItem('token_expiry', String(value.token.expiry));
        this.authService.setUser(this.user);
        if (value.user.kind == userType.agence) {
          this.establishmentService
            .getAgencyByEmail(value.user.email)
            .subscribe({
              next: (res) => {
                this.router.navigateByUrl('/agency/dash');
                localStorage.setItem('id', this.user.id);
                const agency = {
                  id: res?.id,
                  name: res?.name,
                  address: res?.address,
                  email: res?.email,
                  phone: res?.phone,
                  siret: res?.siret,
                };
                localStorage.setItem('agency', JSON.stringify(agency));
              },
              error: (err) => {
                console.log('err', err);
                this.cookieService.deleteAll()
                this.authService.disconnect();
                this.loading = false;
              },
            });
        }
        else if (value.user.kind == userType.agence_user) {
          this.establishmentService
            .getAgencyByEmail(value.user.email)
            .subscribe({
              next: (res) => {
                this.router.navigateByUrl('/agency/dash');
                localStorage.setItem('id', this.user.id);
                const agency = {
                  id: res?.id,
                  name: res?.name,
                  address: res?.address,
                  email: res?.email,
                  phone: res?.phone,
                  siret: res?.siret,
                };
                localStorage.setItem('agency', JSON.stringify(agency));
              },
              error: (err) => {
                console.log('err', err);
                this.cookieService.deleteAll()
                this.authService.disconnect();
                this.loading = false;
              },
            });
        }
        else if (value.user.kind == userType.etablissement) {
          this.establishmentService
            .getEstablishmentById(value.user.id)
            .subscribe({
              next: (res) => {
                
                this.router.navigateByUrl('/dashboard/accueil');
                // this.cookieService.set('establishment', JSON.stringify(res));
                // this.cookieService.set('id', this.user.id);
                localStorage.setItem('id', this.user.id);
                const establishment = {
                  id: res?.id,
                  name: res?.name,
                  adress: res?.adress,
                  ville: res?.ville,
                  numresponsable: res?.numresponsable,
                  codepostale: res?.codepostale,
                  platformManagedBy: res?.platformManagedBy,
                  pays: res?.pays,
                  typeetablissement: res?.typeetablissement,
                  numsiret: res?.numsiret,
                  numfiness: res?.numfiness,
                  fullnamepersonnecontact: res?.fullnamepersonnecontact,
                  mailpersonnecontact: res?.mailpersonnecontact,
                  fonctionpersonnecontact: res?.fonctionpersonnecontact,
                  description: res?.description,
                  nombresalaries: res?.nombresalaries,
                  nombreannuelpatients: res?.nombreannuelpatients

                };
                localStorage.setItem('establishment', JSON.stringify(establishment));

                this.loading = false;
              },
              error: (err) => {
                this.cookieService.deleteAll()
                this.authService.disconnect();
                this.loading = false;
              },
            });
        } else {
          // candidiat
          this.condidatApi.getCondidatById(value.user.collary_id).subscribe({
            next: (res) => {
              localStorage.setItem('id', value.user.collary_id);
              localStorage.setItem(
                'candidat',
                JSON.stringify({
                  id: res.id,
                  firstname: res.firstname,
                  fullname: res.fullname,
                  mailadress: res.mailadress,
                  photo: res.photo,
                  lastname: res.firstname,
                  typePosteDto: res.typePosteDto,
                  typePosteId: res.typePosteId,
                  typeSecteurDto: res.typeSecteurDto,
                  typeSecteurId: res.typeSecteurId,
                  numsiret: res.numsiret,
                  numtel: res.numtel,
                  numsocialsecurity: res.numsocialsecurity,
                  nationality: res.nationality,
                  civility: res.civility,
                })
              );
              localStorage.setItem(
                'typePosteId',
                JSON.stringify(res?.typePosteId)
              );
              const candidat = JSON.stringify({
                id: res.id,
                firstname: res.firstname,
                fullname: res.fullname,
                photo: res.photo,
                mailadress: res.mailadress,
                lastname: res.firstname,
                typePosteDto: res.typePosteDto,
                typePosteId: res.typePosteId,
                typeSecteurDto: res.typeSecteurDto,
                typeSecteurId: res.typeSecteurId,
                numsiret: res.numsiret,
                numtel: res.numtel,
                numsocialsecurity: res.numsocialsecurity,
                nationality: res.nationality,
                civility: res.civility,
              });
              localStorage.setItem(
                'candidat',
                JSON.stringify({
                  id: res.id,
                  firstname: res.firstname,
                  fullname: res.fullname,
                  photo: res.photo,
                  mailadress: res.mailadress,
                  lastname: res.firstname,
                  typePosteDto: res.typePosteDto,
                  typePosteId: res.typePosteId,
                  typeSecteurDto: res.typeSecteurDto,
                  typeSecteurId: res.typeSecteurId,
                  numsiret: res.numsiret,
                  numtel: res.numtel,
                  numsocialsecurity: res.numsocialsecurity,
                  nationality: res.nationality,
                  civility: res.civility,
                })
              );
              this.router.navigateByUrl('/accueil');
              this.loading = false;
            },
            error: (err) => {
                this.cookieService.deleteAll()
                this.authService.disconnect();
                this.loading = false;
              this.loading = false;
            },
          });
        }
      },
      error: (e) => {
        let msg = 'Les informations saisies sont incorrectes';
        if (e.error.message == "User is disabled") {
          msg = "Votre compte n'est pas encore activé";
          this.showVerificationCodeForm = true;
        }
        this.flag.displayFlag(
          msg, FlagType.error
        );
        this.loading = false;
      },
    });
  }

  handleVerificationCode() {
    this.authService.activate(this.form.value.email, this.form.value.code).subscribe({
      next: (res) => {
        this.showVerificationCodeForm = false;
      },
      error: (e) => {
        this.flag.displayFlag('Le code de vérification est incorrect', FlagType.error);
      }
    })
  }
}
